import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryEntry() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            按类型精准查找，<strong className="text-primary-500 font-medium">恋爱</strong>、<strong className="text-accent-500 font-medium">热血</strong>、奇幻，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 bg-background-100 rounded-lg p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-medium text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.count.toLocaleString()}部
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <Link
            to="/category/fantasy"
            className="group relative h-48 md:h-56 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20artistic%20illustration%2C%20magical%20dreamy%20atmosphere%20with%20floating%20sparkles%20and%20ethereal%20light%2C%20soft%20pastel%20lavender%20and%20warm%20gold%20color%20palette%2C%20clean%20gradient%20background%2C%20no%20characters%2C%20elegant%20and%20mystical%20vibe%2C%20high%20quality%20digital%20art&width=900&height=500&seq=feature-banner-fantasy&orientation=landscape"
              alt="奇幻漫画专区"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="text-xs bg-accent-500 text-white px-2.5 py-1 rounded-md font-medium mb-2 inline-block">
                热门分类
              </span>
              <h3 className="text-xl font-heading font-bold text-white">
                奇幻漫画专区
              </h3>
              <p className="text-sm text-white/70 mt-1">
                1100+部奇幻韩漫等你探索
              </p>
            </div>
          </Link>

          <Link
            to="/category/romance"
            className="group relative h-48 md:h-56 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20artistic%20illustration%2C%20romantic%20soft%20atmosphere%20with%20delicate%20flower%20petals%20floating%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20clean%20gradient%20background%2C%20no%20characters%2C%20elegant%20and%20sweet%20vibe%2C%20high%20quality%20digital%20art&width=900&height=500&seq=feature-banner-romance&orientation=landscape"
              alt="恋爱漫画专区"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="text-xs bg-primary-500 text-white px-2.5 py-1 rounded-md font-medium mb-2 inline-block">
                人气最高
              </span>
              <h3 className="text-xl font-heading font-bold text-white">
                恋爱漫画专区
              </h3>
              <p className="text-sm text-white/70 mt-1">
                1280+部浪漫韩漫等你来读
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}